import { env } from '@ria-client/env';

export const LOGIN_PATH = '/api/nts/v1/login';

type SegmentTrackingAttributesType = {
  anonymousUserId: string;
  deployableName: string;
  deployableVersion: string;
  driverContentId: string;
  driverContentSource: string;
  driverElement: string;
  driverFlowName?: string;
  driverLocation: string;
  driverPageName: string;
  driverPageUrl: string;
  driverPageViewId: string;
  driverSubLocation: string;
  mostRecentTraditionalDeviceId?: string;
};

export type Options = {
  redirectTo: string;
  cancelUrl?: string;
  initialScreen?: 'signin' | 'signup';
} & SegmentTrackingAttributesType;

const AUTH0_ORIGIN =
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://www.nerdwallet.com/'
    : 'https://stage.nerdwallet.biz/';

export function generateAuthLink(options: Options, origin = AUTH0_ORIGIN) {
  const loginURL = new URL(LOGIN_PATH, origin);

  Object.entries(options).forEach(([key, value]) => {
    loginURL.searchParams.append(key, value);
  });

  loginURL.searchParams.append('redirectTo', options.redirectTo ?? window.location.href);
  return loginURL.toString();
}

export function signIn(options: Omit<Options, 'initialScreen'>, origin = AUTH0_ORIGIN) {
  window.location.assign(generateAuthLink({ initialScreen: 'signin', ...options }, origin));
}

export function signUp(options: Omit<Options, 'initialScreen'>, origin = AUTH0_ORIGIN) {
  window.location.assign(generateAuthLink({ initialScreen: 'signup', ...options }, origin));
}

/** @deprecated Prefer `signIn` / `signUp` / `generateAuthLink`. Kept for call-site compatibility. */
export const auth0 = {
  generateAuthLink: (options: Options) => generateAuthLink(options),
  signIn: (options: Omit<Options, 'initialScreen'>) => signIn(options),
  signUp: (options: Omit<Options, 'initialScreen'>) => signUp(options),
};
